<form class="rf" (ngSubmit)="submit()">
  <label class="field" *ngIf="!lockProject; else lockedProject">
    <span class="field-label">Project</span>
    <select class="form-control" name="projectId" [(ngModel)]="projectId" (ngModelChange)="onProjectChange()">
      <option [ngValue]="null">Select a project</option>
      <option *ngFor="let p of projects" [ngValue]="p.id">{{ p.project_name }}</option>
    </select>
  </label>
  <ng-template #lockedProject>
    <div class="field">
      <span class="field-label">Project</span>
      <span class="locked">{{ projectName }}</span>
    </div>
  </ng-template>

  <label class="field narrow" *ngIf="type === 'daily'">
    <span class="field-label">Date</span>
    <input class="form-control" type="date" name="date" [(ngModel)]="date" />
  </label>

  <label class="field" *ngIf="type === 'boq_summary'">
    <span class="field-label">BoQ</span>
    <select class="form-control" name="boqId" [(ngModel)]="boqId">
      <option [ngValue]="null">Latest BoQ</option>
      <option *ngFor="let b of boqs" [ngValue]="b.boq_id">{{ b.boq_code }} — {{ b.boq_name }}</option>
    </select>
  </label>

  <label class="field" *ngIf="type === 'bom_summary'">
    <span class="field-label">BoM</span>
    <select class="form-control" name="bomId" [(ngModel)]="bomId">
      <option [ngValue]="null">Latest BoM</option>
      <option *ngFor="let b of boms" [ngValue]="b.bom_id">{{ b.bom_code }}{{ b.description ? ' — ' + b.description : '' }}</option>
    </select>
  </label>

  <ng-container *ngIf="type === 'deviation'">
    <label class="field narrow">
      <span class="field-label">From</span>
      <input class="form-control" type="date" name="from" [(ngModel)]="from" />
    </label>
    <label class="field narrow">
      <span class="field-label">To</span>
      <input class="form-control" type="date" name="to" [(ngModel)]="to" />
    </label>
  </ng-container>

  <label class="toggle" title="Turn off to build the narrative from rules only">
    <input type="checkbox" name="useAi" [(ngModel)]="useAi" />
    <span>Use AI narrative</span>
  </label>

  <button type="submit" class="primary-btn" [disabled]="!canSubmit">
    {{ busy ? 'Generating…' : 'Generate report' }}
  </button>
</form>
